module.exports = __webpack_public_path__ + "img/calendar.8bf787df.jpg";